import { HttpContextToken } from '@angular/common/http';

/**
 * Marks a request whose errors are handled inline by the caller (e.g. a form
 * validation message) instead of the generic error toast. Set it via the request's
 * HttpContext — HttpResponseInterceptor checks it before calling ErrorHandlerService.
 */
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
